import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import CustomBreadcrumb from 'components/base/CustomBreadcrumb';
import CustomListComponent from 'components/base/CustomListComponent';
import ContentSections from 'components/base/ContentSections';
import MembershipInfoCard from 'components/customer/MembershipInfoCard';
import AuthButton from 'components/base/AuthButton';
import { PermissionCodes } from 'config/PermissionCodes';
import { createAction } from 'utils';
import { ImportResource } from 'models/DownloadImportModel';
import { SEGMENT_TYPE } from 'config/CustomEnums';

const mapPropsToState = (state) => ({
  segment: state.segments.segment,
});

function SegmentDetail({
  segment,
}) {
  const history = useHistory();
  const dispatch = useDispatch();
  const params = useParams();
  const { id } = params;
  
  const customerListInnerRef = useRef();

  const tabs = [
    {
      name: 'Detail',
      content: (
        <div className="scroll-container-common">
          <ContentSections
            sections={[
              <MembershipInfoCard
                title={'INFORMATION'}
                data={segment}
                fields={[
                  [{ title: 'Name', field: 'name' }],
                  [{ title: `Description${segment?.segmentType === SEGMENT_TYPE.STATIC ? "(optional)" : ""}`, field: 'description' }],
                  ...segment?.segmentType !== SEGMENT_TYPE.DYNAMIC ? [[{ title: 'Show in Customer profile', field: 'displayShowInCustomerProfile' }]] : [],
                  ...segment?.segmentType === SEGMENT_TYPE.STATIC 
                    ? [[{
                      title: `Target customer${segment?.numberOfCustomers ? ` (${segment?.numberOfCustomers})` : ""}`,
                      customRender: (
                        <div className="target-customer-list-container customer-detail">
                          <div className="target-customer-list" ref={customerListInnerRef}>
                            {segment?.customers?.length > 0 ? segment?.customers?.map((data) => <li>{data?.label}</li>) : "-"}
                          </div>
                        </div>
                      )
                    }]] 
                    : [[
                      {
                        title: 'Number of customers',
                        field: 'numberOfCustomers',
                      },
                    ]],
                ]}
              />,
              <MembershipInfoCard
                title={'GENERAL'}
                data={segment}
                fields={[
                  [
                    {
                      title: 'Creation time',
                      field: 'displayCreationDate',
                    }
                  ],
                  ...segment?.segmentType !== SEGMENT_TYPE.STATIC ?
                    [[
                      {
                        title: 'Last update time',
                        field: 'displayLastUpdateCustomersDate',
                      }
                    ]] : [],
                  [
                    {
                      title: 'Last modified time',
                      field: 'displayLastModifiedDate',
                    }
                  ],
                  [
                    {
                      title: 'Last modified by',
                      field: 'displayLastModifiedBy',
                    }
                  ],
                ]}
              />,
            ]}
            hidePreview={true}
          // sectionStyle="detail-info-section-item"
          />
        </div>
      ),
    },
  ];

  const buttons = [
    <AuthButton
      title={'Export customer'}
      className="btn-back-button-common btn-download"
      action={() => {
        dispatch({
          type: 'downloadAndImport/createDownloadTask',
          payload: {
            from: ImportResource.customer,
            related: {
              singleSegmentIn: [id],
            }
          }
        });
      }}
    />,
    segment?.defaultSegment
      ? <></>
      : <AuthButton
        className="btn-further"
        onClick={() => {
          // dispatch({ type: 'customerList/clearData' });
          history.push({
            pathname: 'edit/',
          });
        }}
        requires={PermissionCodes.changeSegment}
      >
        Edit
      </AuthButton>,
  ];

  const [activeTab, setActiveTab] = useState(tabs[0].name);

  useEffect(() => {
    dispatch({ type: 'segments/clearData' });

    dispatch(createAction('segments/getOneSegment')({ id, view: true }));
  }, [dispatch, id]);

  return (
    <div className="customer">
      <CustomListComponent
        caution={{
          detail: '',
          title: segment.name,
        }}
        defaultActiveKey={activeTab}
        breadcrumb={<CustomBreadcrumb name={segment.name} />}
        buttons={buttons}
        tabs={tabs}
        onTabChange={(key) => {
          setActiveTab(key);
        }}
      />
    </div>
  );
}

export default connect(mapPropsToState)(SegmentDetail);
